/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react'
import Context from '../context/context'
import { CancelRounded } from '@mui/icons-material';
import { openDB } from 'idb';
import setupStyles from "../css/SetupForm.module.css";
import schemeStyles from "../css/ReferenceScheme.module.css";
import CustomDropDown from './CustomDropDown';

const colorNames = ['blue', 'black', 'grey', 'orange', 'purple', 'red',]
const options = {
    font_size: [
        { label: 'Normal', value: 'normal' },
        { label: 'Large', value: 'large' },
        { label: 'X-Large', value: 'x-large' },
    ]
}

const KDSSetup = ({ close }) => {

    const context = useContext(Context);
    const { updateUnSync, showWarning } = context;
    const [colorsMethod, setColorsMethod] = useState({ method: 1 })
    const [kotSetup, setKotSetup] = useState({});
    const [KDSSetup, setKDSSetup] = useState({})
    const [fontSelect, setFontSelect] = useState({ selected: '', visible: false, options: options?.font_size })

    useEffect(() => {
        const asyncfunc = async () => {
            const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
            const outletStore = db.transaction("outlet", "readonly").objectStore("outlet");
            const currentOutlet = (await outletStore.getAll())[0];
            const dbKotSetup = currentOutlet.kot_setup;

            const colors = {};
            if (currentOutlet?.kot_colors?.length > 0)
                currentOutlet.kot_colors.sort((a, b) => +a.time - +b.time > 0 ? 1 : -1).forEach(i => colors[i.color] = i.time)
            else colorNames.forEach(i => colors[i] = '')

            setKotSetup({ ...dbKotSetup, kot_type: currentOutlet.kot_type })
            setKDSSetup(currentOutlet?.kds_setup)
            setFontSelect(doc => ({ ...doc, selected: currentOutlet?.kds_setup?.font_size || options?.font_size?.[0]?.value }))
            setColorsMethod({
                method: currentOutlet?.kot_colors?.[0] ? 2 : 1,
                colors,
                formState: false
            })
        }
        asyncfunc()
    }, []);

    const updateSyncDocs = async (db, { types, docs }) => {

        const RECON_TIME = new Date().getTime().toString()
        for (const type of types) {
            await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files").put({
                IDENTIFIER: type,
                RECON_TIME,
                [type]: docs[type]
            })
        }

        const tx = db.transaction("reconciliation", "readwrite").objectStore("reconciliation");
        const record = (await tx.getAll())?.find(curr => curr.IDENTIFIER === "others");
        await tx.put({
            IDENTIFIER: "others",
            details: [
                ...(record?.details?.filter(curr => !types?.includes(curr.type)) || []),
                ...(types?.map(type => ({ type, RECON_TIME })))
            ],
        });
    }

    const onSave = async () => {
        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
        const outlet = (await outletStore.getAll())[0];
        const kds_setup = { ...KDSSetup, font_size: fontSelect.selected }
        const updatedValue = {
            ...outlet,
            kds_setup,
            kot_type: kotSetup.kot_type
        };

        if (colorsMethod.method === 2) {
            updatedValue.kot_colors = Object.keys(colorsMethod?.colors)?.map(i => ({ color: i, time: colorsMethod?.colors[i] }))
            const css = window.document.styleSheets[0];
            for (var i = 0; i < css.rules.length; i++) {
                if (css.rules[i].name === 'colorFrames') {
                    css.removeRule(i);
                }
            }
        } else updatedValue.kot_colors = []
        await outletStore.put(updatedValue)

        updateSyncDocs(db, {
            docs: { kds_setup, kot_colors: updatedValue.kot_colors },
            types: ['kds_setup', 'kot_colors']
        })
        updateUnSync()
        close()
    }

    return (
        <div className={schemeStyles.popupContainer}>
            <div className={schemeStyles.popupBody}>
                <h2>Kitchen Display Setup</h2>
                <div>
                    <div className={schemeStyles.formsContainer}>
                        <div className={`${setupStyles.kotGeneral}`}>
                            {+kotSetup?.kot_type === 1 ? <>
                                <div id={setupStyles.colorsMethods}>
                                    <h3>Colors Methods</h3>
                                    <div>
                                        <label htmlFor="manual">
                                            Manual
                                            <input type="radio" name='color-method' id="manual" checked={colorsMethod?.method === 1} onChange={e => e.target.checked && setColorsMethod((curr) => ({ ...curr, method: 1 }))} />
                                        </label>
                                        <label htmlFor="automatic">
                                            Automatic
                                            <input type="radio" name='color-method' id="automatic" checked={colorsMethod?.method === 2} onChange={e => e.target.checked && setColorsMethod((curr) => ({ ...curr, method: 2 }))} />
                                        </label>
                                    </div>
                                </div>
                                <button className={setupStyles.fieldCustomizationButton} style={{ "margin": "auto 0" }} onClick={e => {
                                    e.preventDefault()
                                    setColorsMethod((curr) => ({ ...curr, formState: true }))
                                }} disabled={colorsMethod?.method !== 2}>Setup Colors</button>
                            </> : ''}
                        </div>
                        <div className={`${setupStyles.kotGeneral}`}>
                            <div><h3>Font Size</h3></div>
                            {fontSelect?.options?.length > 1 ?
                                <CustomDropDown
                                    label={'Select Font Size'}
                                    state={fontSelect}
                                    setState={setFontSelect}
                                    onSelect={value => setFontSelect(curr => ({ ...curr, visible: false, selected: value }))}
                                    styles={{ container: { position: 'unset', margin: '0' }, select: { position: 'unset' }, options: { width: "inherit", top: "auto", left: "auto" } }}
                                /> : ''}
                        </div>
                        <div className={`${setupStyles.kotGeneral}`}>
                            <label htmlFor='hide_ready_items' style={{ width: '100%', fontWeight: '700', fontSize: '18px' }}>Hide Ready Item</label>
                            <input
                                type="checkbox"
                                id="hide_ready_items"
                                checked={Boolean(+KDSSetup?.hide_ready_items)}
                                onChange={e => setKDSSetup(curr => ({ ...curr, hide_ready_items: +e.target.checked }))}
                            />
                        </div>
                    </div>
                    <button
                        className={schemeStyles.submitBtn}
                        onClick={onSave}
                        style={{ padding: "10px", width: "100%" }}
                    >Save</button>
                </div>
                <CancelRounded onClick={close} className={schemeStyles.close} />
            </div>
            {colorsMethod?.formState && <ColorsSetupForm showWarning={showWarning} close={() => setColorsMethod(curr => ({ ...curr, formState: false }))} colorsMethod={colorsMethod} setColorsMethod={setColorsMethod} />}
        </div>
    )
}

const ColorsSetupForm = ({ showWarning, close, colorsMethod, setColorsMethod }) => {

    const onSave = () => {
        const colorsTime = Object.values(colorsMethod.colors)
        if (colorsTime.some(j => `${j}` && +j < 1))
            return showWarning({
                message: 'Numbers below 1 not allowed',
                classname: 'active-red'
            })

        let duplicateTime = [];
        for (let i = 0; i < colorsTime.length; i++) {
            duplicateTime.push(colorsTime.filter(j => `${j}` && +j === +colorsTime[i]).length > 1)
        }
        if (duplicateTime.some(i => i))
            return showWarning({
                message: 'Same Numbers cannot exist',
                classname: 'active-red'
            })
        else return close()
    }

    return (
        <div className={schemeStyles.popupContainer}>
            <div className={schemeStyles.popupBody}>
                <h2>KOT Colors Setup</h2>
                <div>
                    <div className={schemeStyles.formsContainer}>
                        {Object.keys(colorsMethod.colors)?.map(c => (
                            <label htmlFor={c} className={setupStyles.colorLabels}>
                                <div style={{ background: c }} className={setupStyles.kotColorCircles}></div>
                                <div>{c.toUpperCase()}</div>
                                <input
                                    type="number"
                                    id={c}
                                    className={setupStyles.colorInputs}
                                    placeholder='Time in minutes'
                                    value={colorsMethod?.colors[c]}
                                    onChange={e => setColorsMethod(curr => ({
                                        ...curr, colors: { ...curr.colors, [c]: +e.target.value }
                                    }))}
                                    min={1}
                                />
                                Minutes
                            </label>
                        ))}
                    </div>
                    <button className={schemeStyles.submitBtn} style={{ padding: '8px', width: '100%' }} onClick={onSave}>Save</button>
                </div>
                <CancelRounded className={schemeStyles.close} onClick={close} />
            </div>
        </div>
    )
}

export default KDSSetup